import { useI18n } from 'builder/hooks/useI18n'
import { TRANSLATION } from '../../../constants'
import { Service } from '../../../../types'
type UpskillStatus = 'initial' | 'progress' | 'completed'

type UpskillInfo = {
  badge: string
  header: string
  subHeader: string
  actionText: string
}

type UpskillHookConfig = {
  isLoading: boolean
  text: UpskillInfo
  status: UpskillStatus
}

export const useUpskillConfig = (service: Service): UpskillHookConfig => {
  const { i18n } = useI18n()
  const progress = service.calculatedProgress?.percentageProgress || 0

  const getStatus = (): UpskillStatus => {
    if (progress >= 100) return 'completed'
    if (progress > 0) return 'progress'
    return 'initial'
  }

  const getText = () => {
    const status = getStatus()
    if (status === 'initial' || status === 'completed') {
      return i18n.t(`${TRANSLATION}.upskill.${status}`) as unknown as UpskillInfo
    }
    return {
      badge: i18n.t(`${TRANSLATION}.upskill.${status}.badge`) as unknown as string,
      header: service?.data?.last_course?.title || '',
      subHeader: service?.data?.last_course?.introduction || '',
      actionText: i18n.t(`${TRANSLATION}.upskill.${status}.actionText`) as unknown as string,
    }
  }

  return {
    isLoading: false,
    text: getText(),
    status: getStatus(),
  }
}
